import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import { getVenueDocRef } from '../firebase/venueFirestore';
import { selectActiveVenueId } from './slices/admin.slice';
import type { AppDispatch, RootState } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useAdminVenueRef = () => {
  const venueId = useAppSelector(selectActiveVenueId);
  return useMemo(() => (venueId ? getVenueDocRef(venueId) : undefined), [venueId]);
};
